<div class="d-block">
  <ul class="nav nav-secondary m-0" role="leaderboardnav" aria-label="leaderboard nav">
    <div class="mixed-loyalty-nav w-100" [ngClass]="{ 'justify-content-start': isRulesEnabled }">
      <a
        class="nav-item leaderboard-nav-item"
        [ngClass]="{ 'nav-item-rules': isRulesEnabled }"
        [routerLink]="['/games/' + routeLink]"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.screenreader' | translate }}"
      >
        <label>{{ routeLink + '.nav.featured' | translate: { fgbdefault: 'Play' } }}</label>
      </a>
      <a
        class="nav-item leaderboard-nav-item"
        [ngClass]="{ 'nav-item-rules': isRulesEnabled }"
        [routerLink]="['/games/' + routeLink + '/leaderboard']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.leaderboard.screenreader' | translate }}"
      >
        <label>{{ 'games.nav.' + routeLink + '.leaderboard' | translate: { fgbdefault: 'Leaderboard' } }}</label>
      </a>
      <ng-container *fgbWebsiteContentFeatureFlag="'feature.flag.fantasy.rules'">
        <a
          *ngIf="isRulesEnabled"
          class="nav-item leaderboard-nav-item"
          [ngClass]="{ 'nav-item-rules': isRulesEnabled }"
          [routerLink]="['/games/' + routeLink + '/how-to-play']"
          [routerLinkActive]="'active'"
          [routerLinkActiveOptions]="{ exact: true }"
          attr.aria-label="{{ 'game.nav.' + routeLink + '.rules.screenreader' | translate }}"
        >
          <label>{{ 'games.nav.' + routeLink + '.how.to.play' | translate: { fgbdefault: 'How to Play' } }}</label>
        </a>
      </ng-container>
    </div>
  </ul>
</div>
